enum PrintDialogFields {
	PRINTER = "printer",
	COPIES = "copies",
	AUTO_ROTATE = "auto_rotate",
	CENTER = "center",
	SHRINK = "shrink",
	EXPAND = "expand",
	PAGERANGE = "pagerange"
}

export default PrintDialogFields;